module.exports = __webpack_public_path__ + "static/media/problems.7822eb43.png";